/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Tool_Trust_Window_Scope_ToolInputs */



/**
* | output |
* | --- |
* | "this tool" |
*
* @param {Chat_Tool_Trust_Window_Scope_ToolInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_tool_trust_window_scope_tool = /** @type {((inputs?: Chat_Tool_Trust_Window_Scope_ToolInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Tool_Trust_Window_Scope_ToolInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("dieses Tool")
	return /** @type {LocalizedString} */ ("this tool")
});